import { HYDRATE } from 'next-redux-wrapper';
import {
    GET_PRODUCTS_SUSPEND_STATE,
    SET_PRODUCTS_SUSPEND_STATE,
    ERROR_PRODUCTS_SUSPEND_STATE,
} from '../actionTypes/productsSuspendState';
import { THydrateAction } from '../index';
import { TSuspendStateActions } from '../actions/productsSuspendState';

const initialState = {
    isFetching: false,
    error: null,
    productsSuspendState: [],
};

export enum EProductsSuspendStatus {
    suspended = 1
}

export interface IProductsSuspendSuspended extends ISerializedProductsSuspendState {
    suspendStatus: EProductsSuspendStatus.suspended
    suspendDateFrom: Date,
    suspendDateTo: Date
}

export interface ISerializedProductsSuspendSuspended extends ISerializedProductsSuspendState {
    suspendStatus: EProductsSuspendStatus.suspended
    suspendDateFrom: string,
    suspendDateTo: string
}

export interface IProductsSuspendOther extends ISerializedProductsSuspendState {
    suspendStatus: Exclude<EProductsSuspendStatus, EProductsSuspendStatus.suspended>
    suspendDateFrom: null,
    suspendDateTo: null
}

export function isSuspendedService(product: IProductsSuspendState): product is IProductsSuspendSuspended {
    return product.suspendStatus === EProductsSuspendStatus.suspended;
}

function isSerializedProductsSuspendSuspended(product: ISerializedProductsSuspendState): product is ISerializedProductsSuspendSuspended {
    return product.suspendStatus === EProductsSuspendStatus.suspended;
}

export interface IStoreProductsSuspendState {
    isFetching: boolean,
    error: string | null,
    productsSuspendState: IProductsSuspendState[]
}

export type IProductsSuspendState = IProductsSuspendOther | IProductsSuspendSuspended

interface ISerializedProductsSuspendState {
    suspendDateFrom: Date | string | null,
    suspendDateTo: Date | string | null,
    suspendStatus: EProductsSuspendStatus,
    planName: string,
    id: string | number,
    suspendPrice: number,
    eddendaId: any,
    productName: string
}

/**
 * Восстанавливаем состояние с бека
 */
function deserializeSuspendState(productsSuspendState: ISerializedProductsSuspendState[]): IProductsSuspendState[] {
    return productsSuspendState.map(function(item) {
        if (isSerializedProductsSuspendSuspended(item)) {
            return {
                ...item,
                suspendDateFrom: new Date(item.suspendDateFrom),
                suspendDateTo: new Date(item.suspendDateTo),
            };
        } else {
            return {
                ...item,
                suspendDateFrom: null,
                suspendDateTo: null,
            } as IProductsSuspendOther;
        }
    });
}

export default function(state: IStoreProductsSuspendState | null = initialState, action: TSuspendStateActions | THydrateAction) {
    switch (action.type) {
        case HYDRATE:
            return {
                ...action.payload.productsSuspendStateInfo,
                productsSuspendState: deserializeSuspendState(action.payload.productsSuspendStateInfo.productsSuspendState),
            };
        case GET_PRODUCTS_SUSPEND_STATE:
            return {
                ...state,
                isFetching: true,
            };
        case SET_PRODUCTS_SUSPEND_STATE:
            return {
                ...state,
                isFetching: false,
                productsSuspendState: action.payload,
            };
        case ERROR_PRODUCTS_SUSPEND_STATE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
